export const OR = '|';
export const AND = '&';
export const NOT = '^';
export const OPEN_BRACKET = '(';
export const CLOSE_BRACKET = ')';
